import React from 'react';
import PropTypes from 'prop-types';

import Slider from 'react-slick';

function Carousel({
  arrows,
  className,
  dots,
  dotsClass,
  infinite,
  speed,
  slidesToShow,
  slidesToScroll,
  children,
  afterChange,
  adaptiveHeight,
}) {
  const settings = {
    afterChange,
    arrows,
    className,
    dots,
    infinite,
    speed,
    slidesToShow,
    slidesToScroll,
    dotsClass: `${dotsClass} slick-dots`,
    adaptiveHeight,
  };
  return <Slider {...settings}>{children}</Slider>;
}

Carousel.defaultProps = {
  arrows: false,
  dots: true,
  infinite: true,
  adaptiveHeight: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  dotsClass: '',
  className: '',
  afterChange: _ => _,
};

Carousel.propTypes = {
  dots: PropTypes.bool,
  infinite: PropTypes.bool,
  arrows: PropTypes.bool,
  adaptiveHeight: PropTypes.bool,
  speed: PropTypes.number,
  slidesToShow: PropTypes.number,
  slidesToScroll: PropTypes.number,
  dotsClass: PropTypes.string,
  className: PropTypes.string,
  afterChange: PropTypes.func,
};

export { Carousel };
